import React from 'react';
import '../Cards.css';
import CardItem from '../CardItem';


function Growlah() {
  window.scrollTo(0, 0)
  return (
    <div>
      <div id='about' className='cards'>
        <h1>GrowLah</h1>
        <h3 className="cards-description">GrowLah! is a joint initiative with Tata Consultancy Services and <a href="https://vedanacci.github.io/index.html">Vedant Bahadur</a> with two key aims: improving food security and improving senior welfare.
          We train seniors to install and maintain hydroponic systems in households, community centers, schools and even the Singapore Science Center.
          We developed cutting-edge IoT sensors that display metrics such as temperature, PH and light on our dashboard.
          <br></br>
          <br></br>
          <a style={{ textDecoration: "none;", color: "green", hover: "red" }} target="_blank" href="https://growlah.web.app/">GrowLah! Website</a>
          <br></br>
          <br></br>
          <a style={{ textDecoration: "none;", color: "green", hover: "red" }} target="_blank" href="https://drive.google.com/drive/folders/1S_bPR-DVkt6jf8XM-ec7jcOBA02aRIQT?usp=sharing">GrowLah! App</a>
          <br></br>
          <br></br>
          <a style={{ textDecoration: "none;", color: "green", hover: "red" }} target="_blank" href="https://growlah-bcb3f.web.app/">GrowLah! Dashboard</a>


        </h3>

        <div className='cards__container'>
          <div className='cards__wrapper'>
            <ul className='cards__items'>

              <CardItem
                src='images/growlah2.jpg'
                text='Hydroponic system Growing leafy green vegetables'
                label="North Vista Primary School"
              />
              <CardItem
                src='images/growlah1.jpg'
                text="Installing IoT sensors"
                label="North Vista Primary School"
              />


            </ul>

            <ul className='cards__items'>
              <CardItem
                src='images/growlah3.jpg'
                text='Installing IoT sensors'
                label="United World College Dover"
              />

              <CardItem
                src='images/growlah5.png'
                text='IoT components'
                label="United World College Dover"
              />

            </ul>

            <ul className='cards__items'>
              <CardItem
                src='images/growlah7.png'
                text='Assembling system'
                label="HNF Buangkok center"
              />

              <CardItem
                src='images/growlah8.png'
                text='Dashboard to monitor systems'
                label="Web Dashboard"
              />

            </ul>
            <ul className='cards__items'>


              <CardItem
                src='images/growlah6.png'
                text='Harvested produce'
                label="North Vista Primary School"
              />

              <CardItem
                src='images/growlah4.jpg'
                text='Planting seeds with senior citizens'
                label="HNF Buangkok center"
              />
            </ul>

          </div>
        </div>
      </div>
    </div>
  )
}

export default Growlah
